/** @format */
import React from "react";
import "./batches.css";
import { TableLoader } from "../../components/loader/Resusable/Table";
import noData from "../../../assets/img/noData.svg";
import dropDown from "../../../assets/img/dropDown-long_icon.svg";
import dropDownActive from "../../../assets/img/dropDown-long_icon_active.svg";
import dropUpActive from "../../../assets/img/dropDown-long_icon_up_active.svg";

export const ScanTable = ({
  thead,
  tbody,
  loading,
  setFilter,
  sortBy,
  order,
}) => {
  return loading ? (
    <TableLoader columns={thead.length} />
  ) : (
    <table
      width="100%"
      cellSpacing="0"
      className="table batchTable intableCheckbox reportScanTable"
    >
      <thead className="pad-topp">
        <tr className="batchesHeader">
          <th className="table_header">
            Scan ID
            <span className={"cursor-pointer"}>
              <img
                src={
                  sortBy === "scanId"
                    ? order === "desc"
                      ? dropDownActive
                      : dropUpActive
                    : dropDown
                }
                alt=""
                onClick={() =>
                  setFilter(
                    "scanId",
                    sortBy === "scanId"
                      ? order === "asc"
                        ? "desc"
                        : "asc"
                      : "asc"
                  )
                }
              />
            </span>
          </th>
          <th className="table_header">
            Product Name
            <span className={"cursor-pointer"}>
              <img
                src={
                  sortBy === "productName"
                    ? order === "desc"
                      ? dropDownActive
                      : dropUpActive
                    : dropDown
                }
                alt=""
                onClick={() =>
                  setFilter(
                    "productName",
                    sortBy === "productName"
                      ? order === "asc"
                        ? "desc"
                        : "asc"
                      : "asc"
                  )
                }
              />
            </span>
          </th>
          <th className="table_header">
            Scan Location
            <span className={"cursor-pointer"}>
              <img
                src={
                  sortBy === "address1"
                    ? order === "desc"
                      ? dropDownActive
                      : dropUpActive
                    : dropDown
                }
                alt=""
                onClick={() =>
                  setFilter(
                    "address1",
                    sortBy === "address1"
                      ? order === "asc"
                        ? "desc"
                        : "asc"
                      : "asc"
                  )
                }
              />
            </span>
          </th>
          <th className="table_header">
            Scanned On
            <span className={"cursor-pointer"}>
              <img
                src={
                  sortBy === "createdAt"
                    ? order === "desc"
                      ? dropDownActive
                      : dropUpActive
                    : dropDown
                }
                alt=""
                onClick={() =>
                  setFilter(
                    "createdAt",
                    sortBy === "createdAt"
                      ? order === "asc"
                        ? "desc"
                        : "asc"
                      : "asc"
                  )
                }
              />
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        {tbody && tbody.length ? (
          tbody.map((th, index) => (
            <tr key={index} className="btachRow history">
              <td>
                <span className="textContol"> {th.scanId}</span>
              </td>
              <td>
                <span className="textContol"> {th.product.productName}</span>
              </td>
              <td>
                <span className="textContol" style={{ WebkitLineClamp: "1" }}>
                  {" "}
                  {th.user.other_info && th.user.other_info.address1
                    ? th.user.other_info.address1
                    : "-"}
                </span>
              </td>
              <td>
                <span className="textContol">
                  {`${th.createdAtDate} | ${th.createdAtTime}`}
                </span>
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td
              colSpan={thead.length}
              className="text-center image-no-data-sm nodataTablePosition"
              // style={{ paddingTop: "150px" }}
            >
              <>
                <img style={{ width: "110px" }} src={noData} alt="" />
                <p>The data you're looking is not available at this moment</p>
              </>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};
